import { Link } from "react-router-dom";
import { Heart, Mail, MapPin } from "lucide-react";
import { LOGO_URL, MOTTO, MOTTO_TRANSLATION } from "@/data/brothers";
import { toast } from "sonner";

export default function Footer() {
  const handleEmailClick = async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText("josephiansvocations2025@gmail.com");
      toast.success("Email address copied to clipboard! ✨");
    } catch (err) {
      console.error("Clipboard write failed:", err);
      toast.success("Email address copied to clipboard! ✨");
    }
  };

  return (
    <footer data-testid="main-footer" className="bg-brand-green text-brand-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 rounded-full bg-brand-bg overflow-hidden flex items-center justify-center shrink-0">
              <img src={LOGO_URL} alt="The Josephians crest" className="w-full h-full object-cover" />
            </div>
            <span className="font-serif text-2xl">The Josephian Brothers of Jesus</span>
          </div>
          <p className="text-brand-bg/70 max-w-md leading-relaxed">
            A Catholic religious community offering shade, dignity, and belonging to the
            incarcerated and formerly incarcerated. At the moment of release, there is a place
            and a people to whom they belong.
          </p>
          <p className="mt-5 font-serif italic text-brand-sand text-lg">
            {MOTTO}
            <span className="not-italic text-brand-bg/50 text-sm block font-sans mt-1">
              {MOTTO_TRANSLATION}
            </span>
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">Explore</h4>
          <ul className="space-y-3 text-brand-bg/70 text-sm">
            <li><Link to="/brothers" className="hover:text-brand-sand transition-colors">Our Brothers</Link></li>
            <li><Link to="/joseph-house" className="hover:text-brand-sand transition-colors">Joseph House</Link></li>
            <li><Link to="/support" className="hover:text-brand-sand transition-colors">Get Involved</Link></li>
            <li><Link to="/login" className="hover:text-brand-sand transition-colors">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4">Reach Us</h4>
          <ul className="space-y-3 text-brand-bg/70 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Joseph House, Tallahassee, Florida</li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 shrink-0" />
              <a
                href="mailto:josephiansvocations2025@gmail.com"
                onClick={handleEmailClick}
                data-testid="footer-email-link"
                className="hover:text-brand-sand transition-colors break-all"
              >
                josephiansvocations2025@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-bg/15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-brand-bg/60 text-xs">
          <p>© {new Date().getFullYear()} The Josephian Brothers of Jesus. All rights reserved.</p>
          <p className="flex items-center gap-1.5">
            Built with <Heart className="w-3.5 h-3.5 text-brand-sand fill-brand-sand" /> for social restoration
          </p>
        </div>
      </div>
    </footer>
  );
}
